<template>
  <div id="stockdetail">
    <el-row>
      <el-col :span="12">
        <ul>
          <li>客户名称：{{ titleData.T_NAME }}</li>
          <li>项&nbsp;&nbsp;&nbsp;&nbsp;目&nbsp;&nbsp;&nbsp;&nbsp;点：{{ titleData.P_NAME }}</li>
          <li>档口：{{ titleData.D_NAME }}</li>
        </ul>
      </el-col>
      <el-col :span="12">
        <ul>
          <li>订单编号：{{ titleData.ORDER_CODE }}</li>
          <li>退货日期：{{ titleData.RETURN_DATE }}</li>
          <li>退货总金额：{{ titleData.TOTAL_RETURN_FEE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="单价"></el-table-column>
          <el-table-column prop="RETURN_COUNT" label="退货数量"></el-table-column>
          <el-table-column prop="RETURN_FEE" label="退货金额"></el-table-column>
          <el-table-column prop="REASON" label="退货理由"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="margin-top: 20px">
        <el-button @click="toPrintTable">打印退货单</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { print } from 'api/warehouseManager';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      titleData: {},
      totalFee: '',
      companyName: '',
    };
  },
  created() {
    this.companyName = sessionStorage.getItem('company');
    this.getRecordDetail();
  },
  methods: {
    // ----------------------拉取数据
    getRecordDetail() {
      this.titleData = JSON.parse(sessionStorage.getItem('returnMess'));
      const params = {
        SERVICE_ID: '10012',
        OTYPE: 8,
        ORDER_ID: Number(sessionStorage.getItem('RETURN_ID')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].DETAIL;
            this.titleData = result[0].TITLE[0];
          } else {
            this.tableData = [];
            this.totalFee = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    toPrintTable() {
      let html = '<div>';
      html += '<div class="main">';
      html += `<div class="title">${this.companyName}销售退货单</div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">项目点：${this.titleData.P_NAME}</div><div style="font-size: 20px;">档口：${this.titleData.D_NAME}</div><div style="font-size: 20px;">日期：${this.titleData.RETURN_DATE}</div></div>`;
      html += `<div class="head"><div class="code" style="font-size: 20px;">退货单编号：${this.titleData.ORDER_CODE}</div><div style="font-size: 20px;">总金额：${this.titleData.TOTAL_RETURN_FEE}</div></div>`;
      html += '<table border="1" cellspacing="0"><div class="el-table__body el-table__header">';
      html += '<tr><th style="width: 50px">序号</th> <th>产品</th> <th>单位</th> <th  style="width: 40px">单价</th> <th style="width: 70px">退货数量</th> <th  style="width: 70px">退货金额</th> <th>退货理由</th> </tr>';
      html += '</div><div class="el-table__body">';
      this.tableData.forEach((item, index) => {
        html += '<tr style="text-align: center">';
        html += `<td> ${index + 1} </td> <td>${item.NAME}</td>  <td>${item.TYPE_UNIT}</td> <td>${item.PRODUCT_PRICE}</td>
                 <td>${item.RETURN_COUNT}</td> <td>${item.RETURN_FEE}</td> <td>${item.REASON}</td>`;
        html += '</tr>';
      });
      html += '</div>';
      html += '</table>';
      html += '</div>';
      html += '<div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 20px;"><div>退货人：</div><div style="margin-left: 200px; font-size: 20px;">主管：</div></div>';
      html += '</div>';
      const windows = print(html);
      windows.close();
    },
  },
};
</script>
<style scoped>
.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}

ul {
  list-style: none;
  min-height: 5px;
  padding: 0
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/tableManage/sellOrderReturnDetail.vue